/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useCallback, useEffect, useState } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import { wxConfig, wxShare } from "@src/utils/wechat"
import { AppContext } from "@src/context"

const APP_BREAKPOINT = 800

const parseItem = (item) => {
  if (typeof item === "string") {
    return <img src={item} alt="" />
  }
  if (typeof item === "function") {
    return item()
  }
  return item
}

const Layout = ({ children, location }) => {
  const [isAppLayout, setIsAppLayout] = useState()
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    const resizeEvent = () => {
      const winWidth = window.document.documentElement.clientWidth
      const isApp = winWidth < APP_BREAKPOINT
      const htmlClassList = window.document.documentElement.classList
      if (isApp) {
        htmlClassList.add("is_app")
      } else {
        htmlClassList.remove("is_app")
      }
      htmlClassList.add("theme-disabled")
      setIsAppLayout(isApp)
      setInitialized(true)
    }
    resizeEvent()
    window.addEventListener("resize", resizeEvent)

    return () => {
      window.removeEventListener("resize", resizeEvent)
    }
  }, [])

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  const renderItem = useCallback(
    (forPc, forApp) => {
      if (isAppLayout) {
        return parseItem(forApp)
      }
      return parseItem(forPc)
    },
    [isAppLayout]
  )

  if (!initialized) {
    return <div />
  }

  return (
    <AppContext.Provider
      value={{
        renderItem,
        parseItem,
        isAppLayout,
        APP_BREAKPOINT,
      }}
    >
      <Seo />
      {/* <Nav location={location} /> */}
      <div className={styles.container}>
        <main>{children}</main>
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
